<template>
  <div>
    <div
      :class="mindDesign ? 'home-mind p' : 'home p'"
      v-bind:style="heightWrapper"
      id="home-wrapper"
      v-if="loaded && widgetVisible == true"
    >
      <div class="boxes">
        <div class="incr">
          <div class="box _0" v-if="!mindDesign">
            <span
              class="text-center"
              style="margin-right: -25px"
              v-if="!config.customer.showCustomerNameInHeader"
              >{{ item.name }}</span
            >
            <span class="text-center" style="margin-right: -25px" v-else>
              {{ topicHeader }}</span
            >
            <span
              @click="hideWidget()"
              style="float: right; margin-right: 10px; cursor: pointer"
              v-if="config.customer.canMinimize"
              ><i class="material-icons spin">remove</i></span
            >
          </div>
          <div v-else-if="mindDesign && main">
            <div class="mind-logo-container">
              <img
                src="../assets/mind-logo-cut.jpg"
                alt="MIND För Psykisk Hälsa"
                style="height: 100%; width: 100%"
                v-if="mindlogoStart"
              />
            </div>
          </div>
          <div
            v-if="0 === 0 && main"
            style="height: 100%; background-color: white"
          >
            <div v-if="!mindDesign">
              <div
                class="show-profile-picture-img"
                v-if="config.customer.showProfilePictures"
              >
                <div
                  class="small-side-by-side"
                  v-for="(pic, index) in groupFullUserData"
                  :key="index"
                  v-bind:style="{
                    backgroundImage: `url(${pic.profileImageUrl})`,
                    'border-color': setBorderColor(
                      `${pic.presence.availability}`
                    ),
                  }"
                ></div>
              </div>

              <div
                class="show-profile-picture-text"
                v-if="config.customer.showProfilePictures"
              >
                Här kan du få snabb hjälp.
              </div>
              <div v-else class="show-profile-picture-text-animation">
                <TextAnim v-show="config.customer.iconToggleView" />
              </div>
              <div class="wait-box" style="display: none">
                <div style="margin-bottom: 40px"></div>
                <div style="margin-bottom: 40px"></div>
                <div style="margin-bottom: 40px"></div>
                <div style="margin-bottom: 0px"></div>
                <div style="margin-bottom: 25px; display: none">
                  {{ slaMail }} h
                </div>
              </div>
              <div
                style="
                  padding: 0 25px;
                  display: flex;
                  flex-directoin: row;
                  justify-content: space-evenly;
                "
              >
                <div class="icons-left-and-text-right" style="width: 30%">
                  <i
                    v-if="config.customer.showBooking"
                    @click="show('taxi')"
                    class="material-icons hover color menu-icons-positioning"
                    >local_taxi</i
                  >
                  <i
                    v-if="config.customer.showFaq"
                    @click="show('faq')"
                    class="material-icons hover color menu-icons-positioning"
                    >find_in_page</i
                  >
                  <i
                    v-if="config.customer.showChat"
                    @click="show('chat')"
                    class="material-icons hover color menu-icons-positioning"
                    >chat</i
                  >
                  <i
                    v-if="config.customer.showMail"
                    @click="show('mail')"
                    class="material-icons hover color menu-icons-positioning"
                    >mail</i
                  >
                  <i
                    @click="show('phone')"
                    class="material-icons hover color menu-icons-positioning"
                    >phone</i
                  >
                  <i
                    v-if="config.customer.showContactCenter"
                    @click="show('website')"
                    class="material-icons hover color menu-icons-positioning"
                    >accessibility</i
                  >
                </div>
                <div class="icons-left-and-text-right" style="width: 50%">
                  <v-col
                    class="menu-options-taxi"
                    @click="show('taxi')"
                    v-if="config.customer.showBooking"
                  >
                    <div style="font-size: 18px; float: left">Boka taxi</div>
                    <div class="color" style="font-size: 12px; float: left">
                      Boka direkt
                    </div>
                  </v-col>
                  <v-col
                    class="menu-options"
                    @click="show('faq')"
                    v-if="config.customer.showFaq"
                  >
                    <div style="font-size: 18px; float: left">FAQ</div>
                    <div class="color" style="font-size: 11px; float: left">
                      Enkla frågor & svar
                    </div>
                  </v-col>
                  <v-col
                    class="menu-options"
                    @click="show('chat')"
                    v-if="config.customer.showChat"
                  >
                    <div style="font-size: 18px; float: left">Chat</div>
                    <div
                      class="color"
                      style="font-size: 12px; float: left; display: block"
                    >
                      <span v-if="openChat">Chatta med oss</span
                      ><span style="color: red" v-else>Chatten är stängd</span>
                    </div>
                  </v-col>
                  <v-col
                    class="menu-options"
                    @click="show('mail')"
                    v-if="config.customer.showMail"
                  >
                    <div style="font-size: 18px; float: left">Mail</div>
                    <div
                      class="color"
                      style="font-size: 12px; float: left; display: block"
                    >
                      Skicka e-post
                    </div>
                  </v-col>
                  <v-col class="menu-options" @click="show('phone')">
                    <div style="font-size: 18px; float: left">Telefon</div>
                    <div class="color" style="font-size: 12px; float: left">
                      {{ config.customer.phoneText }}
                    </div>
                  </v-col>
                  <v-col
                    class="menu-options"
                    @click="show('website')"
                    v-if="config.customer.showContactCenter"
                  >
                    <div style="font-size: 18px; float: left">Kundportal</div>
                    <div
                      class="color"
                      style="font-size: 12px; float: left; display: block"
                    >
                      Hitta medarbetare
                    </div>
                  </v-col>
                </div>
              </div>
              <div style="width: 100%; float: left">
                <br />
                <img
                  :src="config.logo"
                  style="width: 60px; padding-top: 15px; height: auto"
                />
                <div style="width: 100%">
                  <span style="font-size: 8px"
                    >powered by
                    <a href="https://teleoffice.se/?tloclick" target="blank"
                      >teleoffice</a
                    ></span
                  >
                </div>
              </div>
            </div>
            <div v-else>
              <v-col class="welcome-text-container">
                <h1 class="mt-5 mb-5" style="font-size: 3em">Välkommen!</h1>
                <span>
                  <p style="font-size: 1.5em; margin-bottom: 5px">
                    Vi chattar med dig så fort vi kan.
                  </p>
                  <p style="font-size: 1.5em">Tack för att du väntar</p>
                  <br />
                </span>
              </v-col>
              <div class="qiut-btn-container">
                <v-col cols="auto">
                  <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="300"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <hr class="hr-for-qiut-btn-container" />
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="#f27509"
                        class="qiut-btn"
                        >Avsluta</v-btn
                      >
                    </template>
                    <template v-slot:default="dialog">
                      <v-card height="180px" class="pt-8">
                        <h3>Är du säker på att du vill avsluta?</h3>
                        <v-card-actions class="sure-to-quit-card">
                          <v-btn
                            x-large
                            color="#f27509"
                            @click="closePopupLeavPage()"
                            class="text-capitalize"
                            style="color: white"
                            >Ja</v-btn
                          >
                          <v-btn
                            @click="dialog.value = false"
                            x-large
                            color="#f27509"
                            class="text-capitalize"
                            style="color: white"
                            >Nej</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </div>
            </div>
          </div>

          <div v-if="!main" class="inside-wrapper">
            <div
              class="color"
              style="float: left; margin: 10px"
              v-if="showType != 'faq' || showType != 'chat'"
              @click="handleGoBackBtn"
            >
              <i
                class="material-icons"
                v-if="showBackArrow && !mindDesign"
                style="font-size: 30px; cursor: pointer"
                >keyboard_arrow_left</i
              >
              <div v-if="!showBackArrow" style="height: 30px"></div>
            </div>
            <Chat :user="user" v-if="showType == 'chat'" />
            <Mail :user="user" v-if="showType == 'mail'" />
            <Phone :config="config" v-if="showType == 'phone'" />
            <Faq :user="user" v-if="showType == 'faq'" />
            <Book :user="user" v-if="showType == 'taxi'" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="widgetVisible == false" class="icon" @click="showWidget()">
      <i style="padding-top: 20px; color: white" class="material-icons">{{
        whois[0]
      }}</i>
    </div>
  </div>
</template>

<script>
import presenceColor from "@/plugins/presence";
import Phone from "./Phone";
import Mail from "./Mail";
import Chat from "./Chat";
import Faq from "./Faq";
import Book from "./Book";
import TextAnim from "./Small/TextAnim";
import config from "../api/config";

export default {
  data() {
    return {
      mindlogoStart: false,
      showBackArrow: true,
      whois: config.customer.iconToggle,
      topicHeader: "",
      groupInfo: [],
      slaSocialMedia: 1,
      slaMail: 8,
      groups: [],
      dialogCase: false,
      groupFullUserData: [],
      groupMember: [],
      loading: false,
      main: true,
      widgetVisible: false,
      showType: 0,
      user: [],
      loaded: false,
      config: Object,
      heightWrapper: "",
      interVal: "",
      openChat: true,
      mindDesign: config.customer.spacialDesignForMind,
    };
  },
  components: {
    Phone,
    Mail,
    Chat,
    Faq,
    Book,
    TextAnim,
  },
  computed: {
    avgQueingTime() {
      if (this.$store.state.getGroupMembers.avgQueingTime < 60) {
        return this.$store.state.getGroupMembers.avgQueingTime + " sek";
      } else {
        return (
          Math.round(this.$store.state.getGroupMembers.avgQueingTime / 60) +
          " min"
        );
      }
    },
    inQueue() {
      return this.$store.state.getGroupMembers.nrOfCallsInQueue;
    },
    goBack() {
      return this.$store.state.goBack;
    },
    waitBox() {
      return {
        newClass: 1 == 1,
      };
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
  watch: {
    goBack(val) {
      this.main = true;
      this.widgetVisible = true;
      this.showType = 0;
      this.checkIfChatIsOpen();
    },
    main(val) {
      if (val == true) {
        this.setTopics();
        parent.postMessage("normalize", "*");
      }
    },
  },
  created() {
    this.setTopics();
    this.config = config;
    this.loaded = true;
    if(this.config.customer.canMinimize === false) {
      this.widgetVisible = true
    }

    // If there is a active chat go to chat.
    if (
      localStorage.getItem("rand") == null ||
      localStorage.getItem("rand") == "null"
    ) {
    } else {
      this.show("chat");
    }
  },
  mounted() {
    window.addEventListener("_objectStarter", this.receiveMessage);

    if (config.customer.autostartChat) {
      this.main = false;
      this.showType = "chat";
      this.showBackArrow = false;
    }

    this.toogleIcons();

    const showWidget = localStorage.getItem("show");
    if (showWidget != null) {
      this.widgetVisible = JSON.parse(showWidget);
    }
    const id = 0;
    parent.postMessage({ show: this.widgetVisible }, "*");

    if (localStorage.getItem("visitorInfo") === null) {
    } else {
      parent.postMessage(id, "*");
    }
  },
  sockets: {
    connect: function () {
      // uniqueChat
      this.checkIfChatIsOpen(this.config.customer.uniqueChat);
    },
    chatOpenState: function (data) {
      this.setChatState(data);
    },
  },
  methods: {
    handleGoBackBtn() {
      this.main = !main
    },
    closePopupLeavPage() {
      localStorage.setItem("rand", null);
      // localStorage.removeItem("chatQuit");
      this.disableSendField = true;

      if (config.customer.goToUrlOnClose == true) {
        // config.server
        // let postMessageText = `returnToSite&${config.returnWebsite}`;
        // parent.postMessage(postMessageText, "*");
        window.parent.location.href = config.returnWebsite;
      } else {
        this.$store.dispatch("goBack");
      }
      this.dialog = false;
    },
    receiveMessage(data) {
      // console.log("DATA", data);
    },
    setChatState(data) {
      if (data === true) {
        this.openChat = true;
      } else {
        this.openChat = false;
      }
    },
    checkIfChatIsOpen(uniqueChatId) {
      if (
        localStorage.getItem("rand") != null ||
        localStorage.getItem("rand") != "null"
      ) {
        this.$socket.emit("isChatOpen",uniqueChatId);
      }
    },
    toogleIcons() {
      this.interVal = window.setInterval(() => {
        this.pollIcon();
      }, 5000);
    },
    pollIcon() {
      const first = this.whois.shift();
      this.whois = this.whois.concat(first);
    },
    hideWidget() {
      this.toogleIcons();
      this.widgetVisible = false;
      localStorage.setItem("show", false);
      parent.postMessage({ show: false }, "*");
    },
    showWidget() {
      clearInterval(this.interVal);
      parent.postMessage({ show: true }, "*");
      this.widgetVisible = true;
      localStorage.setItem("show", true);
    },
    setTopics(type) {
      switch (type) {
        case "phone":
          this.topicHeader = "Ring oss";
          break;
        case "chat":
          this.topicHeader = "Chatta med oss här";
          break;
        case "mail":
          this.topicHeader = "Skicka mejl";
          break;
        case "faq":
          this.topicHeader = "Frågor & Svar";
          break;
        case "taxi":
          this.topicHeader = "Boka taxi";
          break;

        default:
          this.topicHeader = config.company;
          break;
      }
    },
    show(type) {
      if (type == "chat" && this.openChat === false) {
        return;
      }

      if (type == "mail" && config.customer.mailToLink === true) {
        window.open("mailto:" + config.customer.mailToMailtoLink, "_blank");
        return;
      }

      if (type == "website") {
        window.open(
          "https://tele2.swyx.se/service-portal/#/groupview?groupId=2",
          "_blank"
        );
        return;
      }

      this.setTopics(type);

      this.showType = type;
      this.main = !this.main;
      if (this.showType == "taxi") {
        this.heightWrapper = "700px !important";
        parent.postMessage("bookingWidget", "*");
      }
    },
    setBorderColor(presenceId) {
      return presenceColor.setPresenceColor(presenceId);
    },
    getAllMembersofGroup: function () {
      this.$store
        .dispatch("getGroupMembers", config.customer.group)
        .then((response) => {
          this.groupMembers = response.users;
          this.groupName = response.groupName;
          this.loaded = true;
        });
    },
    getThisGroup() {
      this.$store.dispatch("getAllGroups").then((response) => {
        this.groups = [{ data: "0" }, { data: "0" }];

        this.sortClickedGroupFirst();
      });
    },
    sortClickedGroupFirst() {
      // Hardcoded group 2
      const idFromRoute = config.customer.group;
      const sortedArr = [];

      for (let index = 0; index < this.groups.length; index++) {
        const element = this.groups[index];

        if (idFromRoute == element.id) {
          sortedArr.unshift(element);
        } else {
          //sortedArr.push(element);
        }
      }

      this.groups = sortedArr;
      return;
    },
  },
};
</script>

<!-- default lbue 471FCD -->
<style lang="scss" scoped>
$primary: rgb(255 209 67);
$colorForBouncer: rgb(255 209 67);

.inside-wrapper {
  width: 100%;
  height: 100%;
  background-color: white;
  // overflow-y: auto;
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 100%;
  }
}

.wait-box {
  float: right;
  // width: 70px !important;
  margin-right: -10px;
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 80px;
    margin-right: 40px;
  }
}

.show-profile-picture-img {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
}

.show-profile-picture-text {
  font-size: 14px;
  width: 98%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.show-profile-picture-text-animation {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  margin-bottom: 25px;
  font-size: 1.2rem;
}

// .icons-left {
//   display: flex;
//   flex-direction: column;
//   // float: left;
//   // width: 30px;
//   // height: 30px;
//   // margin-top: -10px;
//   // margin-left: 65px;
//   // padding: 15px;
//   // @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
//   //   margin-left: 50px;
//   // }
// }

.icons-left-and-text-right {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: $colorForBouncer;
  cursor: pointer;
  -webkit-transition: -webkit-transform 0.8s ease-in-out;
  transition: transform 0.8s ease-in-out;
  animation: ripple 0.7s linear infinite;
}

.icon:hover {
  -webkit-transform: rotate(360deg);
  transform: rotate(360deg);
  background-color: $colorForBouncer;
  opacity: 0.9;
}

@keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba($colorForBouncer, 0.3),
      0 0 0 0.25em rgba($colorForBouncer, 0.3),
      0 0 0 0.75em rgba($colorForBouncer, 0.3);
  }
  100% {
    box-shadow: 0 0 0 0.25em rgba($colorForBouncer, 0.3),
      0 0 0 0.75em rgba($colorForBouncer, 0.3);
  }
}

.color {
  color: $primary;
}

.spin {
  border-radius: 50%;
  -webkit-transition: -webkit-transform 0.8s ease-in-out;
  transition: transform 0.8s ease-in-out;
}
.spin:hover {
  -webkit-transform: rotate(360deg);
  transform: rotate(360deg);
  background-color: $primary;
  opacity: 0.9;
}

.hover {
  -webkit-transition: -webkit-transform 0.8s ease-in-out;
  transition: transform 0.8s ease-in-out;
}

.hover:hover {
  opacity: 0.6;
}

.home {
    position:fixed;
    width:21rem; 
    min-height:480px;
    overflow:hidden !important;
    background-color:white;
    box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.2), 0 1.5px 5px 0 rgba(0, 0, 0, 0.19);
    border-radius:7px;
}

.home-mind {
  position: fixed;
  width: 100%;
  min-height: 100%;
  overflow: hidden !important;
  background-color: white;
}

@media screen and (min-width: 340px) and (max-width: 480px) {
  .home {
    width: 100%;
    height: 100vh;
    border-radius: 0px;
    position: initial;
    top: 0;
    left: 0;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0px;
    overflow: hidden !important;
  }
  .home-mind {
    width: 100%;
    height: 100vh;
    border-radius: 0px;
    position: initial;
    top: 0;
    left: 0;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0px;
    overflow: hidden !important;
  }
}

.incr {
  margin: 0%;
}

.boxes {
  display: flex;
  flex-direction: column;
}

.box {
  flex: 1;
  width: 100%;
  height: 3.25rem;
  flex-basis: auto;
  background-color: #7479f2;
  padding-top: 15px;
  font-size: 1.25rem;
  color: white;
  //background-image: url("../assets/illustrations/tech_black.png");
  background-size: 90%;
  font-weight: bolder;
  opacity: 0.9;
  cursor: pointer;
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    border-radius: 0px 0px 0px 0px;
    overflow: hidden;
  }
}
._2 {
  background-color: #7479f2;
  background-position: 40% 55%;
  height: 3rem;
  padding-top: 0.8rem;
}
._1 {
  background-color: #471fcd;
  background-position: 40% 20%;
  height: 3rem;
  padding-top: 0.8rem;
}
._0 {
  background-color: $primary;
  background-position: -50% 90%;
  cursor: default;
}

.small-side-by-side {
  width: 30px;
  height: 30px;
  flex: none;
  float: left;
  border-radius: 100%;
  background-size: 110%;
  flex-basis: auto;
  margin-left: 10px;
  border: 1.5px solid grey;
  margin: 5px;
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 35px;
    height: 35px;
  }
}

.menu-options {
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.menu-options-taxi {
  width: 100%;
  height: 50px;
  margin-bottom: 10px;
  cursor: pointer;
}

.menu-icons-positioning {
  font-size: 30px;
  /* padding-bottom: 25px; */
  cursor: pointer;
  display: flex;
  height: 100%;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.qiut-btn-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100px;
  width: 100%;
}
.hr-for-qiut-btn-container {
  width: 90vw;
  margin-right: 5vw;
  margin-bottom: 5px;
}
.qiut-btn {
  color: white;
  float: right;
  margin-right: 5vw;
}
.sure-to-quit-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 60%;
}
.welcome-text-container {
  margin-top: 100px;
  height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: space-around;
}
.mind-logo-container {
  position: absolute;
  top: 20px;
  left: 25px;
  height: 100px;
  width: 88px;
}
// // alternative style for bigger button
// .start-chat-btn {
//   color: white;
//   height: 60px !important;
//   width: 180px;
//   font-size: 1.1em;
//   font-weight: bold;
// }
@media only screen and (max-width: 30em) {
  .mind-logo-container {
    top: 25px;
    height: 50px;
    width: 44px;
  }
}
</style>

